module.exports = __webpack_public_path__ + "static/img/nav_bg.fa1b743f.jpg";